/* src/app/private/components/tickets/delete-bulk-ticket/delete-bulk-ticket.component.scss */
/*# sourceMappingURL=delete-bulk-ticket.component.css.map */
